<template>
  <div>
    <el-form :model="params" ref="queryForm">
      <QS-search maxLine="1">
        <el-form-item label="查询时间"  prop="queryTime">
          <el-date-picker
            v-model="params.queryTime"
            type="datetimerange"
            start-placeholder="开始日期"
            range-separator="至"
            end-placeholder="结束日期"
            clearable>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="公户单位名称" prop="corporateCode">
          <QS-select
            clearable
            v-model="params.corporateCode"
            filterable
            placeholder="请选择"
            :option-data="corporateList"
            :option-config="{
              labelKey: 'name',
              valueKey: 'code',
            }"
          >
          </QS-select>
        </el-form-item>
        <el-form-item label="查询状态"  prop="queryState">
          <el-select
            v-model="params.queryState"
            placeholder="请选择"
            clearable>
            <el-option value="" label="全部"></el-option>
            <el-option
              v-for="item in queryStateList"
              :key="item.value"
              :value="item.value"
              :label="item.label" />
          </el-select>
        </el-form-item>
        <template slot="moreBtn">
          <el-form-item>
            <el-button
              :loading="onLoading.search"
              type="primary"
              size="small"
              @click="queryList"
            >
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
            <el-button size="small" @click="reset"> 重置 </el-button>
          </el-form-item>
        </template>
      </QS-search>
    </el-form>
    <div class="violation-query">
      <div class="query-btn">
        <el-button
          type="primary"
          @click="dialogInfo.visible = true"
          :disabled="syncScanBtnDisabled"
        >
          扫码同步12123数据
        </el-button>
      </div>
      <div class="query-options">
        <el-checkbox-group v-model="violationParams.operateTypes" @change="handleOperateTypesChange">
          <el-checkbox
            v-for="option in violationOptions"
            :key="option.value"
            :label="option.value"
            :disabled="option.disabled"
          >
            {{ option.label }}
          </el-checkbox>
        </el-checkbox-group>
        <el-tooltip effect="dark" placement="top" v-if="violationSameDisplayIsShow">
          <div slot="content">
            <div class="item">
              1、点击后，通过12123扫码登录。违章查询是必选功能，违章同显是可选功能。
            </div>
            <div class="item">
              2、违章查询及违章同显功能，仅支持车务系统已录入的备案车辆。
            </div>
            <div class="item">
              3、违章同显，仅支持车务系统中租赁中状态下的车辆。
            </div>
          </div>
          <i class="QS-icon-question-outline"></i>
        </el-tooltip>
      </div>
    </div>
    <QS-common-table
      :loading="onLoading.search"
      :pagination="paginationData"
      :data="tableData"
      :columns="queryRecordHeadData"
      @change="paginationChange"
      class="mt16"
    ></QS-common-table>

    <el-dialog
      :visible.sync="dialogInfo.visible"
      title="扫码登录查询"
      width='650px'
      :destroy-on-close="true"
      :close-on-click-modal="false"
      >
      <QRCodeLogin
        :dialogVisible="dialogInfo.visible"
        :operateTypes="violationParams.operateTypes"
        @cancelDialog="cancelDialog"
      />
    </el-dialog>
  </div>
</template>
<script>
import config, { STATE_MAP } from '../config/account'
// eslint-disable-next-line import/no-cycle
import { violationRecordList, corporateList, isShowViolationSameDisplay } from '@/api/domain/carsService'
import moment from 'moment'
import QRCodeLogin from './components/qrCodeLogin.vue'


export default {
  components: {
    QRCodeLogin,
  },
  data() {
    const { queryRecordHeadData } = config.call(this)
    return {
      dialogInfo: {
        visible: false,
      },
      params: {
        queryState: '',
        corporateCode: '',
        queryTime: [],
      },
      violationParams: {
        operateTypes: ['1'],
      },
      violationOptions: [
        {
          value: '1',
          label: '违章查询',
        },
      ],
      onLoading: {
        search: false,
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      queryRecordHeadData,
      tableData: [],
      queryStateList: [],
      corporateList: [],
    }
  },
  mounted() {
    // map 转 list
    for (const key of Object.keys(STATE_MAP)) {
      this.queryStateList.push({
        value: key,
        label: STATE_MAP[key],
      })
    }
    this.getCorporateList()
    this.queryList()
    this.getIsShowViolationSameDisplay()
    this.invokeScanDialog()
  },
  activated() {
    this.invokeScanDialog()
  },
  methods: {
    // 勾选项变化时，移除特殊值 '5'
    handleOperateTypesChange(val) {
      const filtered = (val || []).filter((v) => v !== '5')
      // 仅在存在 5 时才写回，避免触发不必要的更新
      if (filtered.length !== val.length) {
        this.violationParams.operateTypes = filtered
      }
    },
    cancelDialog(refreshList) {
      this.dialogInfo.visible = false
      this.reset()
      refreshList && this.getCorporateList()
      refreshList && this.queryList()
    },
    getCorporateList() {
      corporateList().then(({ code, data }) => {
        if (code === 1) {
          this.corporateList = data
        }
      })
    },
    queryList() {
      this.onLoading.search = true
      const params = {
        queryState: this.params.queryState,
        corporateCode: this.params.corporateCode,
        pageNum: this.paginationData.pageNum,
        pageSize: this.paginationData.pageSize,
      }
      if (this.params.queryTime && this.params.queryTime.length === 2) {
        params.beginQueryTime = moment(this.params.queryTime[0]).format('YYYY-MM-DD HH:mm:ss')
        params.endQueryTime = moment(this.params.queryTime[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      violationRecordList(params).then(({ code, data }) => {
        if (code === 1) {
          this.tableData = data?.items || []
          this.paginationData.total = data?.totalNum || 0
        }
      }).finally(() => {
        this.onLoading.search = false
      })
    },
    reset() {
      this.$refs.queryForm.resetFields()
      this.paginationData.pageNum = 1
      this.queryList()
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageNum = pagination.pageNum
      this.paginationData.pageSize = pagination.pageSize
      this.queryList()
    },
    getIsShowViolationSameDisplay() {
      isShowViolationSameDisplay().then(({ code, data }) => {
        if (code === 1) {
          if (data) {
            this.violationOptions.push({
              value: '3',
              label: '违章同显',
              disabled: false,
            })
          }
        }
      })
    },
    invokeScanDialog() {
      const { invokeScan } = this.$route.params
      if (invokeScan) {
        this.dialogInfo.visible = true
        this.violationParams.operateTypes = ['5']
      }
    },
  },
  computed: {
    violationSameDisplayIsShow() {
      return this.violationOptions.some((item) => item.value === '3')
    },
    syncScanBtnDisabled() {
      return this.violationParams.operateTypes.length === 0 || this.violationParams.operateTypes.includes('5')
    },
  },
}
</script>
<style lang="less" scoped>
.u-dialog {
  .u-dialog-tips {
    background: #ECF3FF;
    border-radius: 5px;
    padding: 10px;
    margin-bottom: 20px;
  }
}
.violation-query {
  display: flex;
  align-items: center;
}
.query-options {
  display: flex;
  align-items: center;
  margin-left: 20px;
}
</style>
